import { render, staticRenderFns } from "./ImageScannerOcrDemo.vue?vue&type=template&id=74630d53"
import script from "./ImageScannerOcrDemo.vue?vue&type=script&lang=ts"
export * from "./ImageScannerOcrDemo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports